module.exports = function getResource(label, vars = []) {
    let resources = {
        new: 'Nouveauté'
    };
    return resources[label];
};
